import { EQUIPMENT_TYPE_VIEW } from '@/fixtures'

export default {
  path: 'equipment-type',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Equipment Type',
      component: () => import('@/views/menus/EquipmentType/Index'),
      meta: {
        permission: EQUIPMENT_TYPE_VIEW
      }
    }
  ]
}
